import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext();

export const useOrder = () => useContext(OrderContext);

export const OrderProvider = ({ children }) => {
  const [orderSessionId, setOrderSessionId] = useState(null);

  const setOrderPlaced = (sessionId) => {
    setOrderSessionId(sessionId);
  };

  const clearOrderSession = () => {
    setOrderSessionId(null);
  };

  return (
    <OrderContext.Provider
      value={{
        orderSessionId,
        setOrderPlaced,
        clearOrderSession
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};
